import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/google.png'
import _imports_2 from '../assets/wechat.png'


const _withScopeId = n => (_pushScopeId("data-v-72e06b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "格布小包"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "login-option"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "g-button g-button-primary login-btn" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 微信登录 ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "login-option" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "login-option"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("p", null, "提示:"),
  /*#__PURE__*/_createElementVNode("p", null, "Google账号与微信账号暂不互通,请使用常用账号登录")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "privacy-policy" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.gblinker.com/docs/terms-of-service.html",
    target: "_blank"
  }, " 使用条款 "),
  /*#__PURE__*/_createTextVNode(" | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.gblinker.com/docs/privacy.html",
    target: "_blank"
  }, " 隐私协议 ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-overlay-dialog" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "el-dialog",
    "aria-modal": "true",
    role: "dialog",
    "aria-label": "微信扫码登录",
    style: {"--el-dialog-width":"340px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "el-dialog__header" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "el-dialog__title" }, "微信扫码登录")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "el-dialog__body" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "qrcode" }, [
        /*#__PURE__*/_createElementVNode("div", { id: "wechat-qrcode" })
      ])
    ])
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileLoginModel = _resolveComponent("MobileLoginModel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isWechatPhone && !(_ctx.isBytedanceWebview() && _ctx.isTikTok()))
          ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getGoogleLoginCode && _ctx.getGoogleLoginCode(...args))),
                class: "g-button g-button-primary login-btn"
              }, [
                _hoisted_5,
                _createTextVNode(" Google登录 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isWechatPhone)
          ? (_openBlock(), _createElementBlock("section", {
              key: 1,
              class: "login-option",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.jumpToWxAuthPage && _ctx.jumpToWxAuthPage(...args)))
            }, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_8, [
          (!_ctx.isWechatPhone)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "g-button g-button-primary login-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.qrcodeLogin && _ctx.qrcodeLogin(...args)))
              }, [
                _hoisted_9,
                _createTextVNode("   微信登录 ")
              ]))
            : _createCommentVNode("", true)
        ]),
        ((_ctx.isBytedanceWebview() && _ctx.isTikTok()) || !_ctx.isWechatPhone)
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleModel && _ctx.toggleModel(...args))),
                class: "g-button g-button-primary login-btn"
              }, "  验证码登录 ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_11,
      _hoisted_12
    ]),
    _createVNode(_component_MobileLoginModel, {
      "is-show-model": _ctx.isShowBindMobileModel,
      onClose: _ctx.toggleModel
    }, null, 8, ["is-show-model", "onClose"]),
    (_ctx.isShowQrcodeDialog)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "qrcode-dialog",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowQrcodeDialog = false))
        }, _hoisted_14))
      : _createCommentVNode("", true)
  ], 64))
}